import { CSProvider, useCSContext } from "context/useCSContext";

import { Context } from "context/checkbox-group/CheckboxGroupContext";
import React from "react";
import { useCheckboxGroup } from "queries/checkboxGroupsQueries";
import { usePageFeedback } from "utils";

type CheckboxGroupProviderProps = {
  id: number;
  children: React.ReactNode;
};

/**
 * CheckboxGroupProvider wraps a chunk of code to provide the state of
 * the current question.
 */
export const CheckboxGroupProvider = ({ id, children }: CheckboxGroupProviderProps) => {
  const feedback = usePageFeedback();

  const { data: currentCheckboxGroup } = useCheckboxGroup(id, { onError: feedback.handleErrorWithMessage });

  return (
    <CSProvider
      Context={Context}
      args={{ currentCheckboxGroup }}
      requiredKeys={["currentCheckboxGroup"]}
      feedback={feedback}
    >
      {children}
    </CSProvider>
  );
};

/**
 * Functionally provides the currently selected CheckboxGroup
 */
export const useCheckboxGroupState = () => {
  const contextShape = useCSContext({
    Context,
    noProviderMsg: "CheckboxGroup Context used without CheckboxGroup Provider.",
  });

  return {
    ...contextShape,
    currentCheckboxGroupId: contextShape.currentCheckboxGroup.groupId,
  };
};
